<template>
  <div class="details-view">
    <cargo-left-right-resize
      v-show="Boolean(action)"
      :left-style="{flex:'none','min-width': '180px','max-width':'220px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template v-show="action==='look'" slot="left">
        <div style="min-width: 180px;width:100%;height:100%;padding:10px 0px 10px;">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="gridOptions"
            :row-data="rowData"
            :check-sub-record="false"
            :check-main-record="false"
            :deselect-main-record="false"
            :deselect-sub-record="false"
            class="section"
            style="min-width: 160px;width:100%;height:100%;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers">
              <cargo-button-group-slider>
                <div v-show="action==='look'">
                  <el-button no="1" type="primary" @click="backEventFlag=true">{{ $t('common.btn.back') }}</el-button>
                  <el-button no="2" :disabled="!(currentRow && currentRow.jobState == -1 && !isEditing)" type="primary" @click="onAdd()">{{ $t('common.btn.new') }}</el-button>
                  <!--编辑-->
                  <el-button v-show="$checkPermission(['button_fmVerify_edit'])" no="3" type="success" @click="toEdit">{{ $t('common.btn.edit') }}</el-button>
                  <el-button no="4" :disabled="!(currentRow && currentRow.jobState === -1 && !isEditing)" type="primary" @click="copyJobHandler()">{{ $t('SeaExport.Clone') }}</el-button>
                  <el-button
                    v-if="isHc && job.prePortPlanner > 0 && job.prePortApproveStatus === SystemConstants.PRICE_STATE_REVIEW.code && ($store.getters.isAdmin || $store.getters.userId === job.prePortPlanner)"
                    no="showPrePortAuditBtn"
                    type="primary"
                    @click="p=>{priceAuditCommand=$t('CargoMsg.Cargo_preportAudit');priceAuditHandle()}"
                  >{{ $t('CargoMsg.Cargo_preportAudit') }}</el-button>
                  <el-button
                    v-if="isHc && job.planner > 0 && job.trunkLineApproveStatus === SystemConstants.PRICE_STATE_REVIEW.code && ($store.getters.isAdmin || $store.getters.userId === job.planner)"
                    no="showTrunkLineAuditBtn"
                    type="primary"
                    @click="p=>{priceAuditCommand=$t('CargoMsg.Cargo_TrunkLineAudit');priceAuditHandle()}"
                  >{{ $t('CargoMsg.Cargo_TrunkLineAudit') }}</el-button>
                  <el-button
                    v-if="isHc && job.prePortPlanner > 0 && job.lastMileApproveStatus === SystemConstants.PRICE_STATE_REVIEW.code && ($store.getters.isAdmin || $store.getters.userId === job.lastMilePlanner)"
                    no="showLastMileAuditBtn"
                    type="primary"
                    @click="p=>{priceAuditCommand=$t('CargoMsg.Cargo_TailEndAudit');priceAuditHandle()}"
                  >{{ $t('CargoMsg.Cargo_TailEndAudit') }}</el-button>
                  <!--审核通过-->
                  <el-button v-show="$checkPermission(['button_fmVerify_accept']) && !isCooperate" no="5" :disabled="!(currentRow && currentRow.jobState === -1 && !isEditing && btn.acceptRole && (currentRow.preverifyState !== 5 && currentRow.preverifyState !== 2 && currentRow.preverifyState !== 3))" type="primary" @click="acceptHandler(1)">{{ $t('SeaExport.PassAudit') }}</el-button>
                  <!--拒绝-->
                  <el-button v-show="$checkPermission(['button_fmVerify_reject']) && !isCooperate" no="6" :disabled="!(currentRow && currentRow.jobState === -1 && !isEditing && btn.rejectRole && (currentRow.preverifyState !== 5 && currentRow.preverifyState !== 2 && currentRow.preverifyState !== 3))" type="primary" @click="rejectHandler(1)">{{ $t('SeaExport.Refuse') }}</el-button>
                  <!--协作状态: 审核通过-->
                  <el-button v-show="$checkPermission(['button_fmVerify_accept']) && isCooperate" no="7" :disabled="!(currentRow && !isEditing && btn.acceptRole && [SystemConstants.COOPERATE_STATUS_PENDING.code].includes(currentRow.cooperateStatus))" type="primary" @click="acceptCooperateHandler(1)">{{ $t('SeaExport.PassAudit') }}</el-button>
                  <!--协作状态: 拒绝-->
                  <el-button v-show="$checkPermission(['button_fmVerify_reject']) && isCooperate" no="8" :disabled="!(currentRow && !isEditing && btn.rejectRole && [SystemConstants.COOPERATE_STATUS_PENDING.code].includes(currentRow.cooperateStatus))" type="primary" @click="rejectHandler(1)">{{ $t('SeaExport.Refuse') }}</el-button>
                  <!--打印-->
                  <el-button no="9" :disabled="btn.enablePrint" type="primary" @click="onPrint">{{ $t('SeaExport.print') }}</el-button>
                  <!--复核通过-->
                  <el-button v-show="$checkPermission(['button_fmVerify_reviewThrough']) && btn.pretrialReviewConfig && !isCooperate" no="10" :disabled="!(currentRow && currentRow.jobState === -1 && !isEditing && btn.pretrialReviewThroughRole && btn.pretrialReviewConfig && currentRow.preverifyState === 2)" type="primary" @click="btVerifyReviewThroughHandler(1)">{{ $t('SeaExport.VerifyReviewThrough') }}</el-button>
                  <!--复核拒绝-->
                  <el-button v-show="$checkPermission(['button_fmVerify_reviewRefusal']) && btn.pretrialReviewConfig && !isCooperate" no="11" :disabled="!(currentRow && currentRow.jobState === -1 && !isEditing && btn.pretrialReviewRefusalRole && btn.pretrialReviewConfig && currentRow.preverifyState === 2)" type="primary" @click="btVerifyReviewRefusalHandler(1)">{{ $t('SeaExport.VerifyReviewRefusal') }}</el-button>
                </div>
                <div v-show="isNew" class="new" style="border-left:none;padding-left:0">
                  <el-button no="12" type="success" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <el-button no="13" type="success" @click="cancelEdit(openMultiple?goBackAtMultiple:goBack)">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="SaveTheDefaultValues" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
                <div v-show="action==='edit'" class="btn-group-edit" style="border-left:none;padding-left:0">
                  <el-button no="14" type="success" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <el-button
                    no="15"
                    type="success"
                    @click="cancelEdit(openMultiple?againLookAtMultiple:lookHandler)"
                  >{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="SaveTheDefaultValues2" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
              </cargo-button-group-slider>
              <div v-show="action==='look'||action==='edit'" style="display: flex; white-space: nowrap;">
                <!-- im入口 -->
                <CargoIm v-show="imCacheKey && action==='look'" ref="cargoIm" />
                <el-tooltip effect="dark" :content="$t('SeaExport.Tip2')" placement="bottom-start">
                  <img :src="locationImg" style="width: 20px;margin-right: 5px;" @click="toQueryDataPushLog">
                </el-tooltip>
                <el-tooltip effect="dark" :content="action==='edit' ? '' : $t('SeaExport.Tip1')" placement="bottom-start" :offset="sopTooltipOffset" :visible-arrow="false">
                  <div style="width: 100%;cursor: pointer" @mousemove="resetSopTooltip" @dblclick="onBtnListDoubleClicked()">
                    <span class="red" style="font-size:14px;padding:5px 0">{{ commonInfo.jobState }}</span>
                    <span style="font-size:12px;padding: 5px 9px;color:unset;" v-html="commonInfo.jobTitle" />
                    <span class="red" style="font-size:12px;padding:5px 0">{{ commonInfo.jobLock }}</span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="tabs-container">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              :before-leave="(activeName,oldActiveName)=>{beforeLeaveTab(activeName,oldActiveName)}"
              style="width:100%;"
              @tab-click="handleTabClick"
            >
              <el-tab-pane
                v-if="!masterFlag && (privilege.seBooking.bookingTab || isVerify)"
                :key="1"
                :lazy="true"
                name="tabBookingFCL"
                :label="$t('SeaExport.Basic')"
              >
                <tab-booking-FCLUICustom v-if="$store.state.uiCustom.enable" ref="tabBookingFCL" :slave-customs-declaration-enable="slaveCustomsDeclarationEnable" :context="context" :action="action" :cooperate-edit="cooperateEditOther" :processing-promise-list="processingPromiseList" />
                <tab-booking-fcl v-else ref="tabBookingFCL" :slave-customs-declaration-enable="slaveCustomsDeclarationEnable" :context="context" :action="action" :cooperate-edit="cooperateEditOther" :processing-promise-list="processingPromiseList" />
              </el-tab-pane>
              <el-tab-pane
                v-if="masterFlag && (privilege.seBooking.bookingTab || isVerify)"
                :key="2"
                :lazy="true"
                name="tabBookingMaster"
                :label="$t('SeaExport.Basic')"
              >
                <tab-booking-master-UICustom
                  v-if="$store.state.uiCustom.enable"
                  ref="tabBookingMaster"
                  :context="context"
                  :action="action"
                  :is-sea-export="true"
                  :cooperate-edit="cooperateEditOther"
                  view-source="bookingWorkspace"
                  :processing-promise-list="processingPromiseList"
                  @addLcl="addBatchLcl"
                  @selectJob="jobUuid=>{transferTargetRow('edit', jobUuid)}"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @removeJob="removeJob"
                />
                <tab-booking-master
                  v-else
                  ref="tabBookingMaster"
                  :context="context"
                  :action="action"
                  :is-sea-export="true"
                  :cooperate-edit="cooperateEditOther"
                  view-source="bookingWorkspace"
                  :processing-promise-list="processingPromiseList"
                  @addLcl="addBatchLcl"
                  @selectJob="jobUuid=>{transferTargetRow('edit', jobUuid)}"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @removeJob="removeJob"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && (privilege.seBooking.vesselEqTab || privilege.salesQueryModule.vesselEqTab || isVerify)"
                :key="3"
                :lazy="true"
                name="tabVesselEq"
                :label="$t('SeaExport.Booking')"
              >
                <tab-vessel-eq-UICustom v-if="$store.state.uiCustom.enable" ref="tabVesselEq" :slave-customs-declaration-enable="slaveCustomsDeclarationEnable" :context="context" :action="action" :cooperate-edit="cooperateEditBooking" view-source="verifyWorkspace" />
                <tab-vessel-eq v-else ref="tabVesselEq" :slave-customs-declaration-enable="slaveCustomsDeclarationEnable" :context="context" :action="action" :cooperate-edit="cooperateEditBooking" view-source="verifyWorkspace" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!masterFlag && paramsOfTab.usCustomsClearance"
                key="tabUsCustomsClearance"
                :lazy="true"
                name="tabUsCustomsClearance"
                :label="$t('queryJob.UsCustomsClearance')"
              >
                <tab-us-customs-clearance ref="tabUsCustomsClearance" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="masterFlag && paramsOfTab.usCustomsClearance"
                key="tabUsCustomsClearanceMaster"
                :lazy="true"
                name="tabUsCustomsClearanceMaster"
                :label="$t('queryJob.UsCustomsClearance')"
              >
                <tab-us-customs-clearance-master ref="tabUsCustomsClearanceMaster" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && (masterFlag || paramsOfTab.signMBL) && privilege.seBooking.mbl"
                :key="4"
                :lazy="true"
                name="tabMBL"
                label="MB/L"
              >
                <tab-mbl ref="tabMBL" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @resetTab="resetTab" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.seBooking.mbl2 && (paramsOfTab.typeMBL !== 0 && paramsOfTab.typeMBL !== 1)"
                :key="5"
                :lazy="true"
                name="tabMBL2"
                :label="'MB/L'+(paramsOfTab.typeMBL===2?$t('CargoMsg.Cargo_SplitBL'):'')+(paramsOfTab.typeMBL===3?$t('SeaExport.MergeAndSingle'):'')"
              >
                <tab-mbl2 ref="tabMBL2" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.signHBL && !paramsOfTab.mblOnly && !masterFlag && privilege.seBooking.hbl"
                :key="6"
                :lazy="true"
                name="tabHBL"
                label="HB/L"
              >
                <tab-hbl ref="tabHBL" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @resetTab="resetTab" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !paramsOfTab.mblOnly && !isNew && privilege.seBooking.hbl2 && (paramsOfTab.typeHBL !== 0 && paramsOfTab.typeHBL !== 1)"
                :key="7"
                :lazy="true"
                name="tabHBL2"
                :label="'HB/L'+(paramsOfTab.typeHBL===2?$t('CargoMsg.Cargo_SplitBL'):'')+(paramsOfTab.typeHBL===3?$t('SeaExport.MergeAndSingle'):'')"
              >
                <tab-hbl2 ref="tabHBL2" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.warehousing && privilege.seBooking.warehouseTab"
                :key="8"
                :lazy="true"
                name="tabWarehouse"
                :label="$t('SeaExport.WarehouseLoading')"
              >
                <tab-warehouse ref="tabWarehouse" :context="context" :action="action" :cooperate-edit="cooperateEditWarehouse" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.landTransportation && privilege.seBooking.seTruckingPage"
                :key="9"
                :lazy="true"
                name="tabTruckingForSe"
                :label="$t('SeaExport.Trucking')"
              >
                <tab-trucking-for-se ref="tabTruckingForSe" :context="context" :action="action" :cooperate-edit="cooperateEditTrucking" />
              </el-tab-pane>
              <!-- 目的港派车tab -->
              <el-tab-pane
                v-if="paramsOfTab.dischargingPortDoor"
                key="tabDischargingTrucking"
                :lazy="true"
                name="tabDischargingTrucking"
                :label="$t('SeaExport.DispatchVehiclesAtDestination')"
              >
                <tab-discharging-trucking ref="tabDischargingTrucking" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <!-- 目的港清关数据tab -->
              <el-tab-pane
                v-if="paramsOfTab.destPortCustomsClearance"
                key="tabDestinationCustomsData"
                :lazy="true"
                name="tabDestinationCustomsData"
                :label="$t('SeaExport.PortOfDestinationCustomsClearance')"
              >
                <tab-destination-customs-data ref="tabDestinationCustomsData" :context="context" :action="action" :force-readonly="true" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !masterFlag && privilege.seBooking.containersLayer"
                :key="10"
                :lazy="true"
                name="tabContainer"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <tab-container ref="tabContainer" :slave-customs-declaration-enable="slaveCustomsDeclarationEnable" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && masterFlag && !isNew && privilege.seBooking.lclManagerLayer"
                :key="11"
                :lazy="true"
                name="tabLclContainer"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <!-- 装箱信息tab name需要与下面一致-->
                <tab-lcl-container-multi-so-no-mode
                  v-if="masterCustomsDeclarationEnable"
                  ref="tabLclContainer"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @split="splitHandle"
                />
                <tab-lcl-container
                  v-else
                  ref="tabLclContainer"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @split="splitHandle"
                />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && paramsOfTab.ams && !masterFlag && privilege.seBooking.ams"
                :key="12"
                :lazy="true"
                name="tabAMS"
                label="AMS/ENS"
              >
                <tab-ams ref="tabAMS" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !(isLclMaster && isNew) && privilege.charge.chargeView"
                :key="13"
                :lazy="true"
                name="tabCharges"
                :label="$t('SeaExport.Charge')"
              >
                <tab-charges ref="tabCharges" :context="context" :action="action" view-source="BookingVerify" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.chargeConfirm.chargeConfirmView"
                :key="14"
                :lazy="true"
                name="tabInternalBill"
                :label="$t('SeaExport.InternalBillInfo')"
              >
                <tab-internal-bill ref="tabInternalBill" :context="context" :action="action" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.billTab.billTabView"
                :key="15"
                :lazy="true"
                name="tabOverseaBill"
                :label="$t('SeaExport.OverseaBillInfo')"
              >
                <tab-oversea-bill ref="tabOverseaBill" :context="context" :action="action" view-source="BookingVerify" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.seBooking.fileTab"
                :key="16"
                :lazy="true"
                name="tabFile"
                :label="$t('SeaExport.DocumentCirculation')"
              >
                <tab-file ref="tabFile" :context="context" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !masterFlag && paramsOfTab.cargoType && paramsOfTab.cargoType !== 'GC' && privilege.seBooking.specialGoodsTab"
                :key="17"
                :lazy="true"
                name="tabSpecialGoods"
                :label="$t('SpecialGoods.label')"
              >
                <tab-special-goods ref="tabSpecialGoods" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && privilege.seBooking.portalState && !isNew"
                :key="18"
                :lazy="true"
                name="tabSopState"
                :label="$t('SeaExport.BusinessStatus')"
              >
                <tab-sop-state ref="tabSopState" :context="context" :action="action" :cooperate-edit="cooperateEditOther" :sop-template-config="sopTemplateConfig" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.fileHistory.fileHistoryView"
                :key="19"
                :lazy="true"
                name="tabFileHistory"
                :label="$t('SeaExport.FileHistory')"
              >
                <tab-file-history ref="tabFileHistory" :context="context" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      ref="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 数据推送变更记录弹窗 -->
    <el-dialog
      v-if="dataPushDialog.visible"
      v-el-drag-dialog
      :visible.sync="dataPushDialog.visible"
      :title="$t('SeaExport.DataPushChangeLog')"
      width="580px"
      :close-on-click-modal="false"
      class="app-main-inner"
      @close="dataPushDialog.visible=false"
    >
      <div
        class="app-main-inner-row"
        style="padding: 0;display: flex;flex-direction: column"
        :style="{width:'100%',height:'400px',overflow:'auto'}"
      >
        <div v-for="(title,index) in dataPushDialog.titles" :key="index">
          <div style="background:#EBECF5">
            <b>{{ title }}</b>
          </div>
          <div v-for="(item,index) in dataPushDialog.dataMap.get(title)" :key="index">
            <div>{{ item }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- SOP操作状态弹窗 -->
    <sop-state-dialog :hide-window="isEditing" :visible.sync="sopStateDialog.visible" :is-need-refresh.sync:="sopStateDialog.isNeedRefresh" :default-is-expand="sopStateDialog.defaultIsExpand" :job="job" :is-need-expand.sync="sopStateDialog.isNeedExpand" @handleClose="sopStateDialogClose" />
    <!-- 订舱审核-通过 -->
    <op-verify-frame-dialog
      v-if="opVerifyFrameDialog.visible"
      :visible.sync="opVerifyFrameDialog.visible"
      :job-model="opVerifyFrameDialog.job || {}"
      :batch-pass-audit="opVerifyFrameDialog.batchPassAudit"
      :submit-call-back="opVerifyFrameDialog.submitCallBack"
      :job-list="opVerifyFrameDialog.jobList || []"
    />
    <!-- 订舱审核-拒绝 -->
    <op-verify-frame-reject
      v-if="rejectWindow.visible"
      :visible.sync="rejectWindow.visible"
      :job-no="rejectWindow.jobNo"
      :reject-call-back="rejectWindow.rejectCallBack"
    />
    <!-- 预估利润率验证弹窗-->
    <estimate-validation-dialog
      ref="estimateValidationDialog"
      :visible.sync="estimateValidationDialog.visible"
      :job="estimateValidationDialog.job"
      :estimate-profit-rate="estimateValidationDialog.estimateProfitRate"
      :tatol-profit="estimateValidationDialog.tatolProfit"
      @callback="estimateValidationDialog.callback"
    />
    <!-- 信控验证弹框 -->
    <confirm-dialog-window
      v-if="confirmDialogWindow.visible"
      :visible.sync="confirmDialogWindow.visible"
      :message-title="confirmDialogWindow.messageTitle"
      :content="confirmDialogWindow.content"
      :show-confirm-btn="confirmDialogWindow.showConfirmBtn"
      :confirm-call-back="confirmDialogWindow.confirmCallBack"
    />
    <!-- 协作状态审核 -->
    <cooperation-verify-dialog
      v-if="cooperationVerifyDialog.visible"
      :visible.sync="cooperationVerifyDialog.visible"
      :job-uuid="cooperationVerifyDialog.jobUuid"
      :cooperate="cooperationVerifyDialog.cooperate"
      :submit-call-back="cooperationVerifyDialog.submitCallBack"
      :sea-job="cooperationVerifyDialog.job"
      :config="cooperationVerifyDialog.config"
      :editable="cooperationVerifyDialog.editable"
    />
    <!-- 多条业务，配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
      :new-job="batchCheckingWindow.newJob"
    />
    <!-- 单条业务，配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
      :new-job="checkingWindow.newJob"
    />
  </div>
</template>

<script>
import locationImg from '@/assets/location24.png'
import { VerifyWorkspaceContext } from './verifyWorkspaceContext'
import { VerifyWorkspacePM } from './verifyWorkspacePM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import URL from '@/api/urlTranslator'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import businessStatusLogDialog from '@/views/cargo/v0/Clearing/components/financeManage/businessStatusLogDialog'
import ediStatusLogDialog from '@/components/Cargo/Job/ediStatusLogDialog'
import bookingSpaceLogDialog from '@/components/Cargo/Job/bookingSpaceLogDialog'
import trustFromWindow from '@/views/cargo/v0/SeaExport/components/booking/tabs/trustFromWindow'
import tabBookingFcl from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCL'
import tabBookingFCLUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCLUICustom'
import tabBookingMaster from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMaster'
import tabBookingMasterUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMasterUICustom'
import tabVesselEq from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabVesselEq'
import tabVesselEqUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabVesselEqUICustom'
import tabPrePlanBooking from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabPrePlanBooking'
import tabPrePlanBookingLcl from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabPrePlanBookingLcl'
import tabMbl from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabMBL'
import tabMbl2 from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabMBL2'
import tabHbl from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabHBL'
import tabHbl2 from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabHBL2'
import tabAms from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabAMS'
import tabSubBill from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabSubBill'
import tabContainer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabContainer'
import tabLclContainer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabLclContainer'
import tabVgm from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabVGM'
import tabWarehouse from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabWarehouse'
import tabTruckingForSe from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabTrucking'
import tabWarehouseIn from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabWarehouseIn'
import tabCustomsInfo from '@/components/Cargo/Job/booking/tabs/tabCustomsInfo'
import tabCustomsInfoOuj from '@/components/Cargo/Job/booking/tabs/ouJian/tabCustomsInfoOuj'
import tabTradeDetail from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabTradeDetail'
import tabTradeCommission from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabTradeCommission'
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import tabInternalBill from '@/components/Cargo/Job/booking/tabs/tabInternalBill'
import tabOverseaBill from '@/components/Cargo/Job/booking/tabs/tabOverseaBill'
import tabAdvanceCharge from '@/components/Cargo/Job/booking/tabs/tabAdvanceCharge'
import tabFile from '@/components/Cargo/Job/booking/tabs/tabFile'
import tabSpecialGoods from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabSpecialGoods'
import tabSopState from '@/components/Cargo/Job/booking/tabs/tabSopState'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import EstimateValidationDialog from '@/components/Cargo/Job/estimateValidationDialog'
import CargoIm from '@/components/Cargo/Common/CargoIm'
import { TabError } from '@/utils/class/TabError'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { Company } from '@/class/model/mdm/Company'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DateUtils from '@/utils/dateUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { ensureExecuteSuccess, deepCopy, sleep, catchErrorTip, MarkManage } from '@/utils/commonUtil'
import { saveSeaBookingSpace, saveCopyJob, approved, preVerifyReject } from '@/api/seaExport/seaExportJob'
import { batchCheckJobsCredit, updateInquiryJobState } from '@/api/booking/job'
import { sortByMultiField } from '@/utils'
import { ManifestInfo } from '@/class/model/booking/ManifestInfo'
import sopStateDialog from '@/components/Cargo/Job/sopStateDialog'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import OpVerifyFrameDialog from '@/views/cargo/v0/SeaExport/components/verify/OpVerifyFrameDialog'
import ConfirmDialogWindow from '@/views/cargo/v0/SeaExport/components/verify/ConfirmDialogWindow'
import OpVerifyFrameReject from '@/views/cargo/v0/SeaExport/components/verify/OpVerifyFrameReject'
import { getLoading } from '@/utils/utilBaseElement'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import cooperationVerifyDialog from '@/components/Cargo/Job/cooperationVerifyDialog'
import { updateState } from '@/api/booking/jobCooperate'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { getCreditInfoByJobUuid } from '@/api/partner/creditInfo'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import tabDischargingTrucking from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabDischargingTrucking.vue'
import tabDestinationCustomsData from '@/views/cargo/v0/Sales/components/remoteBooking/tabs/tabDestinationCustomsData'
import tabUsCustomsClearanceMaster from '@/components/Cargo/Job/booking/tabs/tabUsCustomsClearanceMaster.vue'
import tabUsCustomsClearance from '@/components/Cargo/Job/booking/tabs/tabUsCustomsClearance.vue'
import tabLclContainerMultiSoNoMode from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabLclContainerMultiSoNoMode'
import { SE } from '@/class/cargo/model/parameters/SystemConstants'
import { BB_CARGO_TYPE, BC_CARGO_TYPE, LCL_CARGO_TYPE } from '@/class/cargo/model/parameters/ContainerLoadType'
import { cache } from '@/utils/cacheManager'
import { getSopTemplateConfig } from '@/api/sysManage/baseConfig/businessManage'

export default {
  name: 'VerifyWorkspace',
  components: {
    tabUsCustomsClearance,
    tabUsCustomsClearanceMaster,
    tabDischargingTrucking,
    tabDestinationCustomsData,
    CargoButtonGroupSlider,
    OpVerifyFrameDialog,
    OpVerifyFrameReject,
    ConfirmDialogWindow,
    DropUploader,
    cargoAdvanceSelect, cargoUserSelect, cargoLeftRightResize, cargoTemplateSelectorDialog, businessStatusLogDialog, ediStatusLogDialog, bookingSpaceLogDialog, trustFromWindow,
    tabBookingFcl, tabBookingFCLUICustom, tabBookingMaster, tabBookingMasterUICustom, tabVesselEq, tabVesselEqUICustom, tabPrePlanBooking, tabPrePlanBookingLcl, tabMbl, tabMbl2, tabHbl, tabHbl2, tabAms,
    tabSubBill, tabContainer, tabLclContainer, tabVgm, tabWarehouse, tabTruckingForSe, tabWarehouseIn, tabCustomsInfo, tabCustomsInfoOuj, tabTradeDetail,
    tabTradeCommission, tabCharges, tabInternalBill, tabOverseaBill, tabAdvanceCharge, tabFile, tabSpecialGoods, tabSopState, tabFileHistory,
    CheckingWindow, EstimateValidationDialog, BatchCheckingWindow, sopStateDialog, cooperationVerifyDialog, CargoIm, tabLclContainerMultiSoNoMode
  },
  props: {
    parentContext: {
      type: Object,
      required: true
    },
    openMultiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isHc: false,
      priceAuditCommand: this.$t('CargoMsg.Cargo_preportAudit'),
      locationImg,
      URL,
      imCacheKey: '',
      selectTypeNames: TYPE_NAMES,
      context: new VerifyWorkspaceContext(this.parentContext),
      pm: new VerifyWorkspacePM(this),
      SystemConstants,
      copyJobNum: 0,
      privilege: {
        seBooking: {
          bookingTab: this.$checkPermission(['tab_SEBooking_BookingTab']),
          vesselEqTab: this.$checkPermission(['tab_SEBooking_VesselEqTab']),
          prePlanBooking: this.$checkPermission(['tab_SEBooking_PrePlanBooking']),
          mbl: this.$checkPermission(['tab_SEBooking_MBL']),
          mbl2: this.$checkPermission(['tab_SEBooking_MBL2']),
          hbl: this.$checkPermission(['tab_SEBooking_HBL']),
          hbl2: this.$checkPermission(['tab_SEBooking_HBL2']),
          ams: this.$checkPermission(['tab_SEBooking_AMS']),
          tabSubBill: this.$checkPermission(['tab_SEBooking_TabSubBill']),
          containersLayer: this.$checkPermission(['tab_SEBooking_ContainersLayer']),
          lclManagerLayer: this.$checkPermission(['tab_SEBooking_LclManagerLayer']),
          warehouseTab: this.$checkPermission(['tab_SEBooking_WarehouseTab']),
          seTruckingPage: this.$checkPermission(['tab_SEBooking_SETruckingPage']),
          seCustomsInfo: this.$checkPermission(['tab_SEBooking_SECustomsInfo']),
          fileTab: this.$checkPermission(['tab_SEBooking_FileTab']),
          specialGoodsTab: this.$checkPermission(['tab_SEBooking_SpecialGoodsTab']),
          portalState: this.$checkPermission(['tab_SEBooking_portalState'])
        },
        salesQueryModule: {
          vesselEqTab: this.$checkPermission(['tab_SalesQueryModule_VesselEqTab'])
        },
        charge: {
          chargeView: this.$checkPermission(['tab_Charge_chargeView']),
          advanceCharge: this.$checkPermission(['tab_Charge_advanceCharge'])
        },
        chargeConfirm: {
          chargeConfirmView: this.$checkPermission(['tab_ChargeConfirm_chargeConfirmView'])
        },
        billTab: {
          billTabView: this.$checkPermission(['tab_billTab_billTabView'])
        },
        fileHistory: {
          fileHistoryView: this.$checkPermission(['tab_FileHistory_fileHistoryView'])
        }
      },
      commonInfo: {
        operateNameCode: -1, // 操作code
        jobState: '',
        jobTitle: '',
        invoiceMode: '',
        jobLock: '',
        isCopySellingCharge: false, // 复制应付费用
        needConfirmDuplicateWarehouseNo: false, // 是否要验证进仓编号重复
        synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false, // 提单收发通代码是否同步至基本页签收发通代码
        isPrint: true,
        isPrintOpr: false, // 是否打印操作（由于打印和提交中最后调用的有相同的方法，因此用改参数区分开来）
        detailTitleShowModel: 0, // 标题显示模式
        printEvent: null,
        showMessage: true
      },
      sopTooltipOffset: 0,
      action: '',
      isTrunkLineApprove: false, // 是否是干线审批
      markManage: new MarkManage(),
      backEventFlag: false, // 返回事件标识
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        suppressContextMenu: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 160,
          tooltip: (params) => {
            return params.data ? params.data.jobNo : ''
          },
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              return `<span>${params.value}</span>`
            }
          },
          suppressMenu: true
        },
        columnDefs: [],
        context: {
          componentParent: this
        },
        onCellClicked: async event => {
          const multipleJobViewMode = Number(this.config.get('MultipleJobViewMode')) || 0
          // 双击检测
          if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
            const mark = this.markManage.regenerateMark('onCellClicked')
            await sleep(500)
            if (this.markManage.readMark('onCellClicked') !== mark) {
              return
            }
          }
          this.onCellClicked(event)
        },
        onCellDoubleClicked: event => {
          const multipleJobViewMode = Number(this.config.get('MultipleJobViewMode')) || 0
          if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
            // 中断单击处理
            this.markManage.regenerateMark('onCellClicked')
            this.onCellDoubleClicked(event)
          }
        }
      },
      rowData: [],
      gridApi: null,
      currentRow: {},
      paramsOfTab: {},
      pendTabSet: new Set(),
      isRefresh: false,
      activeTabName: '',
      partner: {}, // 发送分公司-合作伙伴
      relatedJobUUID: '', // 跨tenant委托，接收方的jobUuid
      template: {}, // 跨tenant委托后调用模板，上传到云存储
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaExportJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      lob: 'SE',
      logCommand: this.$t('SeaExport.PortDataPushLog'),
      dataPushDialog: {
        visible: false,
        titles: [],
        dataMap: new Map()
      },
      sopStateDialog: {
        visible: false,
        isNeedRefresh: false,
        job: {},
        defaultIsExpand: false,
        isNeedExpand: false
      },
      isGetNewJobInfoFromDb: false, // 是否从数据库里获取最新job相关信息【暂时用于保存之后取job】
      btn: {
        acceptRole: true, // 新增
        rejectRole: true, // 复制
        pretrialReviewThroughRole: true, // 新增
        pretrialReviewRefusalRole: true, // 复制
        pretrialReviewConfig: false, //
        // 按钮权限
        enablePrint: false, // 打印按钮是否可用
        btnAddEX: true, // 新增
        btnCopyEX: true, // 复制
        btAcceptEX: true, // 审核通过
        btRejectEX: true, // 拒绝
        btVerifyReviewThroughEX: true, // 复核通过
        btVerifyReviewRefusalEX: true // 复核拒绝
      },
      estimateValidationDialog: {
        visible: false,
        job: { estimateAccountsReceivable: 0, estimateAccountsPayable: 0, estimateGrossProfit: 0, situation: '' },
        estimateProfitRate: 0,
        tatolProfit: 0,
        callback: () => {}
      },
      rejectWindow: {
        visible: false,
        jobNo: '',
        rejectCallBack: null,
        type: 0 // 0  =  列表审核通过 1  =  在详情页面审核通过
      },
      opVerifyFrameDialog: { // 审核通过
        visible: false,
        batchPassAudit: false,
        job: null,
        jobList: [],
        result: null, // 审核通过界面所填写的值
        verifyType: 1, // 订舱预审-审核通过类型1、save2 2、approved2 3、batchUpdateJobs 4、batchApproved
        type: 0, // 0  =  列表审核通过 1  =  在详情页面审核通过
        submitCallBack: null
      },
      batchJobList: [], // 批量审核通过的业务列表
      confirmDialogWindow: { // 信控验证使用
        visible: false,
        messageTitle: '',
        content: '',
        confirmCallBack: null,
        showConfirmBtn: ''
      },
      isOtherEdit: false, // 拆分主票，复制业务，都属于新增的数据，uuid为空，但是大部分字段已经有值，不需要走初始化数据操作
      cooperationVerifyDialog: {
        visible: false,
        jobUuid: '',
        cooperate: null,
        submitCallBack: this.toAcceptCooperationVerifyCallBack,
        editable: true,
        job: null,
        config: null
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null,
        newJob: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null,
        newJob: null
      },
      defaultSeaExportJob: null,
      processingPromiseList: [], // 正在处理中的异步操作对象列表
      sopTemplateConfig: {} // SOP模板配置
    }
  },
  computed: {
    user() {
      return this.context.user
    },
    office() {
      return this.context.office
    },
    config() {
      return this.context.config
    },
    isNew() {
      return this.action === 'add' || this.action === 'split' || this.action === 'copy'
    },
    isEditing() {
      return this.action !== 'look'
    },
    masterFlag() {
      return this.paramsOfTab.masterFlag
    },
    isLclMaster() {
      return !!this.paramsOfTab.lclMasterUuid
    },
    isVerify() {
      // 预审
      return false
    },
    job() {
      return this.currentRow
    },
    sideBar() {
      return this.$store.getters.sidebar.opened
    },
    uploadParams() {
      const { job, user } = this
      return {
        jobNo: job.jobNo,
        mbl: job.mbl,
        uuid: job.uuid,
        createdBy: user.userId,
        createChineseName: user.chineseName,
        createEnglishName: user.englishName,
        documentType: 'other',
        documentName: 'other',
        isShared: false,
        op: false,
        sales: false,
        all: false,
        customer: false,
        consignee: false,
        shipper: false,
        destinationAgent: false,
        bookingAgent: false,
        creditRestrictionForBooking: 0 // 是否开启预审信控配置(0-不限制，1-弹窗确认，2-强制拦截)
      }
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return this.config ? Number(this.config.get('useOrderCenterMode')) === 1 : false
    },
    orderCenterBranch() { // 是否接单分公司
      return this.cooperateStatus === -1
    },
    approveCooperationBusiness() { // 是否协作分公司需审核接单分公司的协作业务
      return this.context.config ? Number(this.context.config.get('approveCooperationBusiness')) === 1 : false
    },
    cooperateBranchId() { // 协作分公司
      return this.$store.getters.currentOfficeId
    },
    cooperateStatus() {
      let cooperateStatus = this.paramsOfTab.cooperateStatus === undefined || this.paramsOfTab.cooperateStatus === null ? -1 : this.paramsOfTab.cooperateStatus
      if (this.paramsOfTab.cooperate && this.paramsOfTab.cooperate.cooperateStatus >= 0) {
        cooperateStatus = this.paramsOfTab.cooperate.cooperateStatus
      }
      return cooperateStatus
    },
    cooperateBusinessTypeCode() {
      let cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessTypeCode || ''
      if (!cooperateBusinessTypeCode && this.paramsOfTab.cooperate && this.paramsOfTab.cooperate.businessType) {
        cooperateBusinessTypeCode = this.paramsOfTab.cooperate.businessType
      }
      return cooperateBusinessTypeCode
    },
    cooperateEditCustoms() { // 报关
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Customs')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditTrucking() { // 陆运
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Trucking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditBooking() { // 订舱
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Booking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditWarehouse() { // 仓储
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Warehouse')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditOther() { // 其他
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      if (this.orderCenterBranch) return true
      return false
    },
    isCooperate() { // 是否协作状态
      if (this.useOrderCenterMode && !this.orderCenterBranch && this.approveCooperationBusiness) {
        return true
      }
      return false
    },
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    viewJobNoSet() {
      const openSet = new Set()
      for (const view of this.visitedViews) {
        if (view.path === this.$route.path && view.query && view.query.openNew && view.query.key) {
          openSet.add(view.query.key)
        }
      }
      return openSet
    },
    seMultiSoMode() { // 海运出口开启拼箱小票多SO操作模式
      return this.config ? Number(this.config.get('SEMultiSoMode')) === 1 : false
    },
    slaveCustomsDeclarationEnable() { // 【小票】关单信息 是否可用
      return this.job.lob === SE.code && !this.job.masterFlag && this.seMultiSoMode && [LCL_CARGO_TYPE.code, BB_CARGO_TYPE.code, BC_CARGO_TYPE.code].indexOf(this.paramsOfTab.containerLoadType) >= 0
    },
    masterCustomsDeclarationEnable() { // 【主票】关单信息 是否可用
      return this.job.lob === SE.code && this.job.masterFlag && this.seMultiSoMode && [LCL_CARGO_TYPE.code, BC_CARGO_TYPE.code].indexOf(this.paramsOfTab.containerLoadType) >= 0
    }
  },
  watch: {
    backEventFlag(newVal) {
      if (newVal) {
        this.backEventFlag = false
        return catchErrorTip(() => {
          return this.goBack()
        })
      }
    }
  },
  async created() {
    await this.context.prepareData()
    this.loadConfigData()
    getSopTemplateConfig({ lob: 'SE' }).then(res => {
      this.sopTemplateConfig = res.data
    })
  },
  updated() {
    if (!this.$refs['tabs']) {
      return
    }
    const panes = this.$refs['tabs'].panes
    const tabNameSet = new Set()
    for (const item of panes) {
      tabNameSet.add(item.name)
    }
    // 将失效的tab名称从pendTabSet中移除
    for (const item of [...this.pendTabSet]) {
      if (!tabNameSet.has(item)) {
        this.pendTabSet.delete(item)
      }
    }
  },
  methods: {
    // 公用方法，进入详情每个页签都会调用
    async onShow(action, rowData, selectedRow) {
      this.imCacheKey = sessionStorage.getItem('imCacheKey')
      this.btn.enablePrint = false
      this.loading = getLoading()
      this.selectedRow = selectedRow
      this.$store.dispatch('app/setCanCloseModule', action === 'look')
      this.action = action
      if (!this.activeTabName) {
        this.paramsOfTab.masterFlag = this.currentRow.masterFlag = selectedRow.masterFlag
      }
      /* 先将原始数据赋给currentRow、paramsOfTab，让页面先展示 */
      this.currentRow = selectedRow
      this.paramsOfTab = this.currentRow
      this.$nextTick(() => {
        this.resetActiveTabName()
      })
      this.isOtherEdit = action === 'split' || action === 'copy'
      this.action = action
      if (selectedRow.uuid) {
        this.rowData = rowData
      } else {
        // let oldJob = null
        // 取上次缓存里面存的数据
        // if (LocalStorageUtils.hasConfiguration('verifySeaExportJob')) {
        //   oldJob = LocalStorageUtils.getConfiguration('verifySeaExportJob')
        //   if (oldJob) {
        //     Object.assign(selectedRow, oldJob)
        //     new SeaExportJob(selectedRow).fillDefaultValue()
        //   }
        // }
        if ((!selectedRow.lclNumber && !this.isOtherEdit)) {
          this.context.opDepartment = null
          await Promise.all([this.getDefaultSeaExportJob(), this.context.getOpDepartment(this.office)])
          await this.buildNewRow(selectedRow)
        }
        // CARGO-53866 东丽 新增业务 销售默认带入当前登录人
        await JobUtils.loadingDlwlSales(selectedRow, this)
        selectedRow.jobState = -1
        // LocalStorageUtils.setConfiguration('verifySeaExportJob', selectedRow)
        if (!Object.prototype.hasOwnProperty.call(selectedRow, 'path')) selectedRow.path = ''
        this.rowData = [...rowData, selectedRow]
      }
      this.$nextTick(async() => {
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        this.loading.close()
        this.setGridSelect(selectedRow)
        await this.onRowClicked({ data: selectedRow })
      })
      if (action === 'look') {
        this.getImGroupFunc({ data: this.job })
        const cfg = LocalStorageUtils.getConfiguration('SESopStatusPopupVisible')
        this.sopStateDialog.visible = !!cfg
      }
    },
    // sop 双击事件
    onBtnListDoubleClicked() {
      LocalStorageUtils.setConfiguration('SESopStatusPopupVisible', true)
      this.sopStateDialog.visible = true
      this.sopStateDialog.defaultIsExpand = true
      this.sopStateDialog.isNeedExpand = true
    },
    // sop 关闭处理
    sopStateDialogClose() {
      this.sopStateDialog.defaultIsExpand = true
      LocalStorageUtils.setConfiguration('SESopStatusPopupVisible', false)
    },
    resetActiveTabName() {
      if (this.isNew) {
        this.activeTabName = this.getDefaultActiveName()
      } else {
        const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
        if (activePanes && activePanes.length === 0) {
          this.activeTabName = this.getDefaultActiveName()
        }
      }
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    // 加载配置项
    loadConfigData() {
      this.isHc = String(cache.config.get('ToExoSystem')) === 'HC'
      this.btn.acceptRole = this.$checkPermission(['button_fmVerify_accept'])
      this.btn.rejectRole = this.$checkPermission(['button_fmVerify_reject'])
      this.btn.pretrialReviewThroughRole = this.$checkPermission(['button_fmVerify_reviewThrough'])
      this.btn.pretrialReviewRefusalRole = this.$checkPermission(['button_fmVerify_reviewRefusal'])
      this.btn.pretrialReviewConfig = parseInt(this.config.get('PretrialReview')) === 1
      this.creditRestrictionForBooking = parseInt(this.config.get('CreditRestrictionForBooking'))
    },
    // 新增时 填充默认值
    async buildNewRow(row) {
      // 填充默认值
      new SeaExportJob(row).fillDefaultValue()
      row.signMBL = true
      row.signHBL = true
      row.vgm = true
      row.warehousing = true
      row.landTransportation = true
      row.path = ''
      row.lob = this.lob
      row.cargoType = 'GC'
      row.cargoSource = 'NC'
      row.typeHBL = 1
      row.typeMBL = 1
      row.portCode = this.$t('SeaExport.PlsSeeEIR')
      row.paymentTermHBL = 'PP'
      row.paymentTermMBL = 'PP'
      row.opOffice = this.office.officeId
      row.loadingPortCode = this.office.seaport
      if (this.context.opDepartment && Number(this.context.opDepartment.departmentId) > 0) {
        row.op = this.user.userId
        if (this.user.defaultDepId > 0 && this.user.defaultOfficeId === this.office.officeId) {
          row.opDepartment = this.user.defaultDepId
        } else {
          row.opDepartment = this.context.opDepartment.departmentId
        }
      }
      if (row.masterFlag) {
        row.cargoSource = ''
        row.paymentTermHBL = ''
        row.containerLoadType = 'LCL'
      } else {
        row.jobState = -1
        row.freightTermHBL = 'CY-CY'
        row.containerLoadType = 'FCL'
      }
      row.tradeTerm = '110'
      row.taxNature = 0
      Object.assign(row, this.defaultSeaExportJob)
      row.bookingTerm = 'OS'
      if (row.masterFlag) {
        row.dispatchingPlace = ''
      }
      const shippingTerms = getCacheListByKey(basicCacheKeys.basic_data_ShippingTerm) || []
      row.freightTerm = shippingTerms && shippingTerms.length > 0 ? shippingTerms[0].code : ''
      // CARGO-33632 海运订舱预审模块，新增的待审核业务=0
      row.preverifyState = 1
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        const itemKey = item.data.uuid || item.data.jobUuid
        const rowKey = row.uuid || row.jobUuid
        if (itemKey === rowKey || !itemKey) {
          this.gridApi.setFocusedCell(item.rowIndex, this.gridApi.columnController.getAllDisplayedColumns()[0])
          item.setData(item.data)
          break
        }
      }
    },
    // 重置行数据
    reset(rows) {
      for (const row of rows) {
        // 标识为脏数据
        row.version = 0
        // 重置子表数据
        for (const key in row) {
          if (typeof row[key] === 'object') {
            row[key] = ''
          }
        }
        row.isCompleteRow = false
      }
    },
    onCellClicked(event) {
      this.changeJob(event)
      this.getImGroupFunc(event)
    },
    onCellDoubleClicked(event) {
      const data = event.data
      if (this.openMultiple && data.jobNo === this.$route.query.key) {
        return
      }
      this.gridApi.setRowData(this.rowData)
      this.setGridSelect(this.currentRow)
      if (this.viewJobNoSet.has(data.jobNo)) {
        this.$router.push({ name: 'BookingVerify', query: { openNew: true, key: data.jobNo }})
      } else {
        if (this.viewJobNoSet.size + 1 > 10) {
          this.$message.warning(this.$t('queryJob.TenTicketsAtTheSameTime'))
          return
        }
        const rowData = deepCopy(this.rowData)
        this.reset(rowData)
        this.$router.push({ name: 'BookingVerify', query: { openNew: true, key: data.jobNo }, params: { rowData, activeTabName: this.activeTabName }})
      }
    },
    // 左侧列表切换job
    changeJob(event) {
      const result = event.data
      if (result) {
        if (this.openMultiple) {
          if (result.jobNo === this.$route.query.key) {
            return
          }
          this.gridApi.setRowData(this.rowData)
          this.setGridSelect(this.currentRow)
          if (this.viewJobNoSet.has(result.jobNo)) {
            this.$router.push({ name: 'BookingVerify', query: { openNew: true, key: result.jobNo }})
          } else {
            if (Number(this.config.get('MultipleJobViewMode')) === 2) {
              const rowData = deepCopy(this.rowData)
              this.reset(rowData)
              this.$router.push({ name: 'BookingVerify', query: { openNew: true, key: result.jobNo }, params: { rowData, activeTabName: this.activeTabName, replace: true }})
            }
          }
        } else {
          if (this.viewJobNoSet.has(result.jobNo)) {
            this.gridApi.setRowData(this.rowData)
            this.setGridSelect(this.currentRow)
            this.$router.push({ name: 'BookingVerify', query: { openNew: true, key: result.jobNo }})
          } else {
            // 重新数据库中加载job
            this.isGetNewJobInfoFromDb = true
            result.version = 0
            for (const key in result) {
              if (typeof result[key] === 'object') {
                result[key] = ''
              }
            }
            this.onRowClicked({ data: result })
          }
        }
      }
    },
    // 行点击
    async onRowClicked(event) {
      this.loading = getLoading()
      if (!event.data) {
        this.loading.close()
        return
      }
      this.currentRow = null
      const job = event.data
      const jobVersion = job.version
      // 若选中提单拆并单,则需要找到其父级job
      if (job.dataType && Number(job.dataType) !== 1 && Number(job.dataType) !== 2 && job.jobUuid) {
        for (const item of this.rowData) {
          if (item.uuid === job.jobUuid) {
            this.currentRow = item
            break
          }
        }
      } else {
        // 本身选中就是job
        this.currentRow = job
      }
      this.setGridSelect(this.currentRow)
      let loadCooperate = false
      // 加载job详细信息
      if (!this.currentRow.isCompleteRow || this.isGetNewJobInfoFromDb) {
        const jobModel = new SeaExportJob(this.currentRow)
        if (this.currentRow.uuid) {
          if (!jobVersion || jobVersion === 0) this.currentRow.version = 0 // version为0时可以重新加载job
          await jobModel.loadJobRelated({
            job: !(jobModel.version >= 1), // 脏数据，需要重新载入
            seaEQ: true,
            lclSlaves: this.currentRow.masterFlag,
            charges: true,
            warehouseIn: true,
            warehouseInfo: true,
            trucking: true,
            lclMaster: !this.currentRow.masterFlag,
            seaCargoDoc: !this.currentRow.masterFlag,
            containerUsages: true,
            containers: true,
            cargoBulkDetail: !this.currentRow.masterFlag,
            surchargeTerms: !this.currentRow.masterFlag,
            orderCenterMode: this.useOrderCenterMode,
            cooperateBranchId: this.cooperateBranchId,
            dischargingTrucking: true,
            destPortCustomsDataList: true
          })
          loadCooperate = true
          // 非主票 组装 containers.containerUsage  同 job.containerUsages 指向同一usage
          if (!jobModel.masterFlag) {
            ContainerUtil.buildContainerUsages(this.currentRow)
          }

          if (!this.currentRow.path) {
            this.setBasicData(this.currentRow)
            this.gridApi.refreshCells({ force: true })
          }
        } else {
          jobModel.seaEQ = jobModel.seaEQ || []
          jobModel.lclSlaves = jobModel.lclSlaves || []
          jobModel.charges = jobModel.charges || []
          jobModel.warehouseIn = jobModel.warehouseIn || []
          jobModel.warehouseInfo = jobModel.warehouseInfo || []
          jobModel.trucking = jobModel.trucking || []
          jobModel.seaCargoDoc = jobModel.seaCargoDoc || []
          jobModel.containerUsages = jobModel.containerUsages || []
          jobModel.containers = jobModel.containers || []
          jobModel.cargoBulkDetail = jobModel.cargoBulkDetail || []
          jobModel.surchargeTerms = jobModel.surchargeTerms || []
          jobModel.dischargingTrucking = jobModel.dischargingTrucking || []
          jobModel.destPortCustomsDataList = jobModel.destPortCustomsDataList || []
        }
        this.currentRow.isCompleteRow = true
        this.isGetNewJobInfoFromDb = false
        // console.log('onRowClicked====', this.currentRow, this.currentRow.seaEQ, this.currentRow.lclSlaves)
      }
      // 协作分公司信息
      if (this.useOrderCenterMode) {
        if (loadCooperate && job.cooperate && job.cooperate.uuid) {
          console.log('job.cooperate===', job.cooperate)
          // 记录原值
          job.opOffice_original = job.opOffice // 分公司
          job.op_original = job.op // 操作
          job.csr_original = job.csr // 客服
          job.overseaOp_original = job.overseaOp // 海外操作
          job.dc_original = job.dc // 单证
          job.planner_original = job.planner // 航线负责人
          job.opDepartment_original = job.opDepartment // 操作部门
          //
          job.opOffice = job.cooperate.branchId // 分公司
          job.op = job.cooperate.opId // 操作
          job.csr = job.cooperate.csrId // 客服
          job.overseaOp = job.cooperate.overseaOp // 海外操作
          job.dc = job.cooperate.dcId // 单证
          job.planner = job.cooperate.planner // 航线负责人
          job.opDepartment = job.cooperate.opDepartment // 操作部门
          JobUtils.convertJobFromCooperateInfo(job, job.cooperate)
        }
      }
      this.initInfo()
      this.resetParamsOfTab()
      this.pendTabSet.clear()
      this.context.modifiedData = {}
      this.processingPromiseList = []
      this.$nextTick(() => {
        if (this.isNew) {
          this.activeTabName = this.getDefaultActiveName()
        } else {
          const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
          if (activePanes && activePanes.length === 0) {
            this.activeTabName = this.getDefaultActiveName()
          }
        }
        this.handleTabClick()
      })
    },
    resetParamsOfTab() {
      if (this.action === 'edit') {
        this.paramsOfTab = deepCopy(this.currentRow)
      } else {
        this.paramsOfTab = this.currentRow
        console.log('this.paramsOfTab==========', this.paramsOfTab)
      }
    },
    beforeLeaveTab(activeName, oldActiveName) {
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // tab页签结束后的处理
    async endTabHandler(tabName) {
      const tab = this.$refs[tabName]
      if (!tab) {
        return
      }
      if (tab.endTabHandler && typeof tab.endTabHandler === 'function') {
        const result = tab.endTabHandler()
        if (result instanceof Promise) {
          await result
        }
      }
    },
    // tab页签切换
    handleTabClick() {
      this.loading = getLoading()
      const tabs = ['tabTradeDetail', 'tabTradeCommission', 'tabAdvanceCharge', 'tabSopState', 'tabFileHistory', 'tabFile']
      this.btn.enablePrint = tabs.includes(this.activeTabName)
      this.$nextTick(() => {
        const oldSize = this.pendTabSet.size
        this.pendTabSet.add(this.activeTabName)
        const isRefresh = this.pendTabSet.size > oldSize
        // this.$logger.log('handleTabClick-isRefresh', isRefresh)
        this.$refs[this.activeTabName].onShow(this.paramsOfTab, isRefresh)
        this.loading.close()
      })
    },
    // 编辑
    editHandler(action) {
      this.loading = getLoading()
      new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, 150)
      }).then(async() => {
        if (this.currentRow.jobState !== 0) {
          this.$message.info(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
          this.loading.close()
          return
        }
        if (!await SecurityUtil.canEdit(new SeaExportJob(this.currentRow))) {
          this.$message.info(this.$t('Message.NoPermissionToEditTheJob'))
          this.loading.close()
          return
        }
        this.againShow(action)
      })
    },
    // 合并数据
    againShow(action, row) {
      this.action = action
      this.loading = getLoading()
      const selectedRow = this.isNew ? row || {} : this.currentRow
      this.onShow(action, this.rowData, selectedRow)
    },
    // 保存海运业务【保存业务相关数据】
    async save() {
      if (this.processingPromiseList.length > 0) {
        const processingPromiseList = [...this.processingPromiseList]
        for (const processingPromise of processingPromiseList) {
          try {
            await processingPromise
          } catch (err) {
            console.log(err)
          }
        }
      }
      // 当前页签结束后的处理
      if (this.activeTabName) {
        await this.endTabHandler(this.activeTabName)
      }
      const body = {}
      try {
        for (const item of [...this.pendTabSet, 'other']) {
          let tabData = null
          if (item !== 'other') {
            // 各页签的保存数据
            const getSubmitData = this.$refs[item].getSubmitData
            if (getSubmitData && typeof getSubmitData === 'function') {
              /* 获取各页签需要保存的数据 */
              const result = this.$refs[item].getSubmitData()
              if (result instanceof Promise) {
                tabData = await result
              } else {
                tabData = result
              }
            }
          } else {
            // 被联动修改了的数据
            tabData = this.context.modifiedData
          }

          if (!tabData) continue
          // this.$logger.log('tabData' + item, tabData)
          // 将不同页签相同key的集合进行数据合并
          for (const key in tabData) {
            const tabValue = tabData[key]
            // this.$logger.log('tabValue：' + item, tabValue)
            if (!tabValue) continue // 判断当前页签所传的数据是否有效，无效则不需要合并
            const bodyValue = body[key]
            // this.$logger.log('bodyValue：' + item, bodyValue)
            if (!bodyValue || !Object.prototype.hasOwnProperty.call(body, key)) continue // 判断body中是否存在该key，不存在或者无数据则由下面统一合并
            // 将数组进行合并
            if (Array.isArray(tabValue)) {
              //
              if (Array.isArray(bodyValue)) { // 这里面会将 uuid 相同的费用进行过滤，页签上的优先于 级联改动的数据
                const bodyMap = new Map()
                if (bodyValue && bodyValue.length > 0) {
                  for (const bodyKey of bodyValue) {
                    if (!bodyKey) continue
                    if (Object.prototype.hasOwnProperty.call(bodyKey, 'uuid') && bodyKey.uuid) bodyMap.set(bodyKey.uuid, bodyKey)
                  }
                }
                if (tabValue && tabValue.length > 0) {
                  for (const tabKey of tabValue) {
                    if (!tabKey || bodyValue.includes(tabKey)) continue
                    if (Object.prototype.hasOwnProperty.call(tabKey, 'uuid') && tabKey.uuid && bodyMap.has(tabKey.uuid)) continue
                    bodyValue.push(tabKey)
                  }
                }
              } else {
                tabValue.push(bodyValue)
                body[key] = tabValue
              }
              delete tabData[key]
            }
          }
          Object.assign(body, tabData)
          // this.$logger.log('页签名称：' + item, tabData)
        }
        // 还原接单分公司
        if (this.useOrderCenterMode) {
          if (body.job && body.job.cooperate && body.job.cooperate.uuid) {
            body.job.opOffice = body.job.opOffice_original || body.job.opOffice // 分公司
            body.job.op = body.job.op_original || body.job.op // 操作
            body.job.csr = body.job.csr_original || body.job.csr // 客服
            body.job.overseaOp = body.job.overseaOp_original || body.job.overseaOp // 海外操作
            body.job.dc = body.job.dc_original || body.job.dc // 单证
            body.job.planner = body.job.planner_original || body.job.planner // 航线负责人
            body.job.opDepartment = body.job.opDepartment_original || body.job.opDepartment // 操作部门
            JobUtils.restoreJobFromCooperateInfo(body.job)
          }
        }
        // 复制、拆分主票保存前处理【未点击页签的数据也需要保存】
        this.doNotClickTabData(body)

        // 清空子表数据【原本是在各页签里面的，现在移到公共的地方来】
        if (Reflect.has(body, 'job') && body.job) {
          for (const key in body.job) {
            // 这里必须要删除，不能将其置为空或者undefined，否则复制或者拆分主票没法赋值
            if (typeof body.job[key] === 'object') delete body.job[key]

            // 保存时需要将sop显示列排除
            if (key.indexOf('_sop_') !== -1 && key.startsWith('_sop_')) delete body.job[key]
          }
        }

        // 主票 新增/加入小票 使用
        if (this.currentRow.lclNumber) {
          const job = this.currentRow
          if (job.warehouseInfo) {
            Object.assign(body, { warehouseInfo: job.warehouseInfo })
          }
          if (job.trucking) {
            Object.assign(body, { truckingInfo: job.trucking })
          }
          if (job.seaCargoDoc) {
            Object.assign(body, { seaCargoDoc: job.seaCargoDoc })
          }
        }
        if (this.isNew) {
          // 初始化舱单数据格式化信息
          if (!body.manifestInfos) {
            body.manifestInfos = [new ManifestInfo().fillDefaultValue().getData()]
          }
        }
        this.cleanCircleObject(body)
        this.$logger.log('body', body)
        JobUtils.handleChargeForSave(body)
      } catch (err) {
        this.loading.close()
        if (err instanceof TabError) {
          this.activeTabName = err.tabName
          if (err.message && err.message !== this.$t('CargoMsg.Cargo_QuantityWeightCubageChange')) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
          }
          return
        }
        throw err
      }
      // 在保存前进行校验
      const bodyJob = body.job || null
      if (!(await this.pm.checkBeforeSave(bodyJob))) {
        this.loading.close()
        return
      }

      // 获取复制份数
      if (Reflect.has(body, 'job') && Reflect.has(body.job, 'copyNum') && Number(body.job.copyNum) > 1) {
        this.copyJobNum = Number(body.job.copyNum)
      }

      // 后端触发SOP使用
      if (!this.isNew) body.jobUuid = this.job.uuid

      // 保存业务时判断缓存M单和H单的提单方式是否变更
      if (body.seaCargoDoc && Number(this.config.get('ReleaseTypeDefaultValue')) === 4) {
        for (const doc of body.seaCargoDoc) {
          if (doc.docType === 'MBL') {
            const type = LocalStorageUtilsNew.getConfiguration('SE_MBL_BL_MODEL')
            if (doc.releaseType && doc.releaseType !== type) {
              LocalStorageUtilsNew.setConfiguration('SE_MBL_BL_MODEL', doc.releaseType)
            }
          } else if (doc.docType === 'HBL') {
            const type = LocalStorageUtilsNew.getConfiguration('SE_HBL_BL_MODEL')
            if (doc.releaseType && doc.releaseType !== type) {
              LocalStorageUtilsNew.setConfiguration('SE_HBL_BL_MODEL', doc.releaseType)
            }
          }
        }
      }

      // 获取业务对应的sop模板，若不一致，则提醒是否更换，若一致不处理，若新增，则
      await SopUtil.checkSopTemplate(body.job, this, null, null, this.sopTemplateConfig)

      // 保存 访问数据库
      // 拆分主票 保存处理逻辑【也走这里】
      body.action = this.action
      this.loading = getLoading() // 这个loading要放在验证之后
      await saveSeaBookingSpace(body).then(res => {
        const result = res.data.job
        if (result) {
          Object.assign(this.currentRow, result)
          this.currentRow.version = 0
          this.currentRow.blocked = result.blocked
          this.currentRow.jobUuid = result.uuid
          this.currentRow.dataType = result.masterFlag ? 1 : 2 // 1、主票 1、小票
          if (this.currentRow.lclMasterUuid) {
            if (this.openMultiple && !this.rowData.some(p => p.uuid === this.currentRow.lclMasterUuid)) {
              this.currentRow.path = result.uuid
            } else {
              this.currentRow.path = result.lclMasterUuid + ',' + result.uuid
            }
          } else {
            this.currentRow.path = result.uuid
          }
          this.isRefresh = true
        }
        this.updateCargoDocNo(body.seaCargoDoc)
        // 重置子表数据【将job相关信息置空，然后从库里重新加载】
        for (const key in this.currentRow) {
          if (typeof this.currentRow[key] === 'object') {
            this.currentRow[key] = ''
          }
        }
        this.currentRow.isCompleteRow = false
        const lclSlaves = body.lclSlaves // 先将拆分主票对应的小票记录，保存后使用
        if (this.action === 'split' && lclSlaves && lclSlaves.length > 0) {
          if (!this.currentRow.beSplitedLclUuids) {
            this.currentRow.beSplitedLclUuids = Array.from(lclSlaves, p => p.uuid)
          }
          // 原被拆分的主票uuid集合
          const oldMasterUuidSet = new Set()
          // 更新小票
          const rows = this.rowData.filter(p => this.currentRow.beSplitedLclUuids.includes(p.uuid))
          for (const lcl of rows) {
            oldMasterUuidSet.add(lcl.lclMasterUuid)
            lcl.isCompleteRow = false
            lcl.parentUuid = this.currentRow.uuid
            lcl.lclMasterUuid = this.currentRow.uuid
            lcl.path = this.currentRow.uuid + ',' + lcl.uuid
            lcl.version = 0 // 标识为脏数据，需要重新载入
          }
          this.gridApi.setRowData(this.rowData)
          // 原被拆分的主票，需重新加载
          const oldMasterJobs = this.rowData.filter(p => oldMasterUuidSet.has(p.uuid))
          for (const item of oldMasterJobs) {
            item.isCompleteRow = false
            item.version = 0 // 标识为脏数据，需要重新载入
            // 重置子表数据
            for (const key in item) {
              if (typeof item[key] === 'object') {
                item[key] = ''
              }
            }
          }
        }
      }).catch((err) => {
        if (this.loading) {
          this.loading.close()
        }
        throw err
      })
      // console.log('this.rowData===', this.rowData)
      // 复制多份业务 保存的处理逻辑
      if (this.copyJobNum > 1 && this.currentRow.uuid) {
        await this.saveCopyJobHandle(this.currentRow.uuid, this.copyJobNum - 1)
      }

      // 主票页签新增多个小票，保存的处理逻辑
      if (this.currentRow.lclNumber && this.currentRow.uuid) {
        const job = this.currentRow
        // 更新新增的第一条小票数据
        // await new SeaExportJob(job).loadJobRelated({ job: true })
        job.jobUuid = job.uuid
        job.parentUuid = job.lclMasterUuid
        job.path = job.lclMasterUuid + ',' + job.uuid
        job.dataType = 2 // 小票
        if (job.lclNumber > 1) {
          await this.saveLclJob(job.uuid, job.lclNumber - 1)
        } else {
          this.rowData = [...this.rowData, { ...job }]
        }
        delete job.lclNumber
        // 切换回主票
        this.currentRow = this.rowData.find(p => p.uuid === job.lclMasterUuid)
        this.currentRow.version = 0
        // 重置子表数据【将job相关信息置空，然后从库里重新加载】
        for (const key in this.currentRow) {
          if (typeof this.currentRow[key] === 'object') {
            this.currentRow[key] = ''
          }
        }
      }

      // 保存成功后各业签执行的回调方法
      for (const item of this.pendTabSet) {
        const executeTask = this.$refs[item].executeTask
        if (executeTask && typeof executeTask === 'function') {
          /* 保存成功后的回调 */
          const result = this.$refs[item].executeTask()
          if (result instanceof Promise) {
            await result
          }
        }
      }
      this.loading.close()
      this.isGetNewJobInfoFromDb = true
      if (this.openMultiple) {
        if (this.gridApi) this.gridApi.refreshCells({ force: true })
        if (this.currentRow.jobNo !== this.$route.query.key) {
          const rowData = deepCopy(this.rowData)
          this.reset(rowData)
          this.$message.success(this.$t('Message.SaveSuccessfully'))
          this.$router.push({ name: 'BookingVerify', query: { openNew: true, key: this.currentRow.jobNo }, params: { rowData, replace: true }})
          return
        }
        await this.againShow('look', this.currentRow)
      } else {
        await this.againShow('look', this.currentRow)
        if (JobUtils.isBlockJob(this.currentRow)) {
          // 保存成功之后如果是信控锁住则会弹此提示【Job.as 中的 save方法】
          setTimeout(() => {
            this.$message.warning(this.$t('SeaExport.CheckCreditSaveTip'))
          }, 2000)
        }
      }
      this.$message.success(this.$t('Message.SaveSuccessfully'))
      this.copyJobNum = 0

      // 保存业务触发SOP后需要刷新 SOP操作状态弹框
      if (this.sopStateDialog.visible) {
        setTimeout(() => {
          this.sopStateDialog.isNeedRefresh = true
        }, 3000)
      }
    },
    // 更新MBL、HBL拆单编号
    updateCargoDocNo(seaCargoDoc) {
      if (!seaCargoDoc) {
        return
      }
      for (const item of seaCargoDoc) {
        if (!item.uuid) {
          continue
        }
        if (item.docType === CargoDocConsts.MBL2) {
          const row = this.rowData.find(p => p.uuid === item.uuid)
          if (row) {
            row.jobNo = item.mblNbr2
          }
        } else if (item.docType === CargoDocConsts.HBL2) {
          const row = this.rowData.find(p => p.uuid === item.uuid)
          if (row) {
            row.jobNo = item.hblNbr2
          }
        }
      }
    },
    // 复制、拆分主票保存前处理【未点击页签的数据也需要保存】
    doNotClickTabData(body) {
      const isCopy = this.action === 'copy'
      const isSplit = this.action === 'split'
      const job = this.currentRow
      if (!body || !job || (!isCopy && !isSplit)) return
      // 复制独有
      if (isCopy) {
        if (!Object.prototype.hasOwnProperty.call(body, 'seaCargoDoc') && job.seaCargoDoc && job.seaCargoDoc.length > 0) {
          Object.assign(body, { seaCargoDoc: job.seaCargoDoc })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'warehouseInfo') && job.warehouseInfo && job.warehouseInfo.length > 0) {
          Object.assign(body, { warehouseInfo: job.warehouseInfo })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'trucking') && job.trucking && job.trucking.length > 0) {
          Object.assign(body, { truckingInfo: job.trucking })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'manifestInfos') && job.manifestInfos && job.manifestInfos.length > 0) {
          Object.assign(body, { manifestInfos: job.manifestInfos })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'charges') && job.charges && job.charges.length > 0) {
          Object.assign(body, { charges: job.charges })
        }
      }

      // 拆分主票或者复制共有
      if (!Object.prototype.hasOwnProperty.call(body, 'seaEQ') && job.seaEQ && job.seaEQ.length > 0) {
        Object.assign(body, { seaEQ: job.seaEQ })
      }
      if (!Object.prototype.hasOwnProperty.call(body, 'containers') && job.containers && job.containers.length > 0) {
        Object.assign(body, { containers: job.containers })
      }

      // 拆分主票独有
      if (isSplit) {
        if (!Object.prototype.hasOwnProperty.call(body, 'lclSlaves') && job.lclSlaves && job.lclSlaves.length > 0) {
          Object.assign(body, { lclSlaves: job.lclSlaves })
        }

        // todo 目前处理了从主票装箱拆分入口 被拆分主票的container,seqEq 信息
        if (job.sourceSeqEq) {
          if (job.sourceSeqEq.delseaEQUuids) {
            body.delseaEQUuids = job.sourceSeqEq.delseaEQUuids.join(',')
          }
          if (job.sourceSeqEq.updateSeaEq && job.sourceSeqEq.updateSeaEq.length > 0) {
            if (!body.seaEQ) {
              body.seaEQ = []
            }
            body.seaEQ.push(...job.sourceSeqEq.updateSeaEq)
          }
        }
      }

      // containerUsages 的保存跟随 containers
      /* if (!Object.prototype.hasOwnProperty.call(body, 'containerUsages') && job.containerUsages && job.containerUsages.length > 0) {
        Object.assign(body, { containerUsages: job.containerUsages })
      }*/
    },
    // 清理循环引用
    cleanCircleObject(obj, level = 0, refMap = new Map()) {
      if (!(obj instanceof Object)) {
        return
      }
      if (level === 0) {
        refMap.set(obj, { level })
      }
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const item = obj[key]
          if (item instanceof Object) {
            const ref = refMap.get(item)
            if (ref) {
              if (level > ref.level) {
                if (obj instanceof Array) {
                  obj[key] = undefined
                } else {
                  delete obj[key]
                }
              } else if (level < ref.level) {
                if (ref.parent instanceof Array) {
                  ref.parent[ref.name] = undefined
                } else {
                  delete ref.parent[ref.name]
                }
                ref.level = level
                ref.parent = obj
                ref.name = key
              }
            } else {
              refMap.set(item, { level: level + 1, parent: obj, name: key })
              this.cleanCircleObject(item, level + 1, refMap)
            }
          }
        }
      }
      if (level === 0) {
        for (const arr of refMap.keys()) {
          if (arr instanceof Array) {
            // 从后向前删除，避免待删除元素的index发生变化
            for (let i = arr.length - 1; i >= 0; --i) {
              if (typeof arr[i] === 'undefined') {
                arr.splice(i, 1)
              }
            }
          }
        }
      }
    },
    // 保存剩下的复制业务【后台复制并保存】
    async saveCopyJobHandle(jobUuid, copyNum) {
      //
      const item = {}
      item.jobUuid = jobUuid
      item.branchId = this.$store.getters.currentOfficeId
      // 复制哪些页签的数据
      const lob = this.currentRow.lob
      item.vesselEq = LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob)
      item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob)
      item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob)
      item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
      item.prePlanBooking = LocalStorageUtils.getConfiguration('COPY_PRE_PLAN_BOOKING_' + lob)
      item.copyNum = copyNum
      item.all = true
      item.copyOnly = true // 是否是复制业务，新增业务日志时使用
      await saveCopyJob(item).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          for (const copyJob of newJobList) {
            this.setBasicData(copyJob)
          }
          this.rowData = [...this.rowData, ...newJobList]
        }
        JobUtils.copyFailTip(copyNum, newJobList, this)
      })
    },
    // 给job设置基本信息
    setBasicData(jobData) {
      jobData.jobUuid = jobData.uuid
      jobData.parentUuid = jobData.uuid
      jobData.path = jobData.uuid
      jobData.dataType = 2 // 小票
    },
    // 保存剩下的新增小票业务【后台复制并保存】
    async saveLclJob(jobUuid, copyNum) {
      const item = {
        jobUuid,
        branchId: this.$store.getters.currentOfficeId,
        copyNum,
        all: true,
        copyOnly: false // 是否是复制业务，新增业务日志时使用
      }
      await saveCopyJob(item).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          for (const copyJob of newJobList) {
            this.setBasicData(copyJob)
            copyJob.jobUuid = copyJob.uuid
            copyJob.parentUuid = copyJob.lclMasterUuid
            copyJob.path = copyJob.lclMasterUuid + ',' + copyJob.uuid
            copyJob.dataType = 2 // 小票
          }
          this.rowData = [...this.rowData, ...newJobList]
        }
        JobUtils.copyFailTip(copyNum, newJobList, this)
      })
    },
    // 取消编辑
    cancelEdit(done) {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        if (typeof done === 'function') {
          done()
        }
      }).catch(() => { })
    },
    // 刷新
    refresh() {
      this.isGetNewJobInfoFromDb = true
      this.againShow(this.action, this.job)
      this.updateControlsState()
    },
    // 加载完job走这里
    initInfo() {
      this.updateControlsState()
      this.showJobState()
      this.showJobTitle()
    },
    // 刷新控制按钮
    updateControlsState() {
      const _job = this.currentRow
      if (!_job) return
      if (_job && (this.acceptRole || this.rejectRole)) {
        this.btn.btnAddEX = _job.jobState === -1 && !this.isEditing
        this.btn.btnCopyEX = _job.jobState === -1 && !this.isEditing
        this.btn.btAcceptEX = _job.jobState === -1 && !this.isEditing && this.btn.acceptRole && (_job.preverifyState !== 5 && _job.preverifyState !== 2 && _job.preverifyState !== 3)
        this.btn.btRejectEX = _job.jobState === -1 && !this.isEditing && this.btn.rejectRole && (_job.preverifyState !== 5 && _job.preverifyState !== 2 && _job.preverifyState !== 3)
      }
      if (_job && this.btn.pretrialReviewConfig) {
        // 复核通过
        this.btn.btVerifyReviewThroughEX = _job.jobState === -1 && !this.isEditing && this.btn.pretrialReviewThroughRole && this.btn.pretrialReviewConfig && _job.preverifyState === 2
        // 复核拒绝
        this.btn.btVerifyReviewRefusalEX = _job.jobState === -1 && !this.isEditing && this.btn.pretrialReviewRefusalRole && this.btn.pretrialReviewConfig && _job.preverifyState === 2
      }
    },
    // 业务状态显示
    showJobState() {
      if (!this.currentRow || !this.currentRow.uuid) {
        this.commonInfo.jobState = ''
        this.commonInfo.jobLock = ''
        this.commonInfo.jobChangeState = ''
        return
      }
      this.commonInfo.jobState = ColumnUtils.getJobState(this.currentRow)
      this.commonInfo.jobLock = JobUtils.isBlockJob(this.currentRow) ? this.$t('Message.Locked') : ''
      // 改单状态
      if (Number(this.config.get('IsCommittedAllowAddCost')) === 1) {
        this.commonInfo.jobChangeState = ColumnUtils.getJobChangeState(this.currentRow)
      }
    },
    async showJobTitle() {
      const job = this.currentRow
      let jobTitle = job.jobNo
      if (job.customerId) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === job.customerId)
        if (cmp) {
          const creditTerm = await JobUtils.getSettlementTypeByJobInformation(job, 'customerId')
          const billingType = await Company.loadCustomer(cmp.uuid).then(data => {
            const customerDetail = data.length > 0 ? data[0] : null
            if (customerDetail) {
              const str1 = ` ${this.$t('Message.BillingType')}[${this.$t('Message.ByTicket')}]`
              const str2 = `${this.$t('Message.BillingType')}[${this.$t('Message.Monthly')}]`
              return customerDetail.invoiceMode === 0 ? str1 : str2
            }
            return ''
          })
          jobTitle = '<span style="margin-right:10px">' + jobTitle + '</span><span style="margin-right:10px">' + cmp.chineseName + creditTerm + '</span><span>' + billingType + '</span>'
        }
      }
      this.commonInfo.jobTitle = jobTitle
    },
    // 港区数据推送日志
    async toQueryDataPushLog() {
      this.loading = getLoading()
      await new SeaExportJob(this.job).loadPushHistoryLogs()
      this.loading.close()
      const item = this.job.pushHistoryLogs
      this.dataPushDialog.titles = []
      this.dataPushDialog.dataMap = new Map()
      if (item) {
        const dataArr = []
        for (const k in item) {
          dataArr.push({ 'time': k, 'logs': item[k] })
        }
        // 排序 按时间降序
        sortByMultiField(dataArr, ['time'], true)
        if (dataArr && dataArr.length > 0) {
          for (const data of dataArr) {
            const logs = data.logs
            const firstLog = logs[0]
            let t = '：' + this.$t('SeaExport.DataPush')
            if (Number(firstLog.sourceType) === 1) {
              t = '：' + this.$t('SeaExport.MasterTicketSync')
            } else if (Number(firstLog.sourceType) === 2) {
              t = '：G7' + this.$t('SeaExport.DataPush')
            }
            const labTime = new Date(Number(data.time))
            const title = DateUtils.formatStandardDateTime(labTime) + t
            this.dataPushDialog.titles.push(title)
            const cMap = {}
            let labLog = ''
            const titleVals = []
            for (const h of logs) {
              if (!cMap.hasOwnProperty(h.fieldName + h.targetValue)) {
                if (!h.sourceValue || h.targetValue === h.sourceValue) {
                  labLog = h.fieldName + `：${this.$t('CargoMsg.Cargo_NewValue')}->` + h.targetValue
                } else {
                  //
                  const newValArr = h.targetValue ? h.targetValue.split(' ') : []
                  labLog = h.fieldName + `：${this.$t('CargoMsg.Cargo_OriginalValue')}->` + h.sourceValue + ` ${this.$t('CargoMsg.Cargo_NewValue')}->` + (newValArr && newValArr.length > 0 ? newValArr[0] : '')
                  if (newValArr && newValArr.length > 0) {
                    for (const str of newValArr) {
                      const index = newValArr.indexOf(str)
                      if (index > 0) titleVals.push(str)
                    }
                  }
                }
                // 每一行便是一个div[ labLog -> div]
                titleVals.push(labLog)
              }
              if (h.fieldName === '箱种' || h.fieldName === this.$t('SeaExport.ContainerSize')) {
                cMap[h.fieldName + h.targetValue] = h.fieldName + h.targetValue
              }
            }
            this.dataPushDialog.dataMap.set(title, titleVals)
          }
        }
      }
      this.dataPushDialog.visible = true
    },
    againLookAtMultiple() {
      this.currentRow = this.rowData.find(p => p.jobNo === this.$route.query.key)
      this.againShow('look')
    },
    goBackAtMultiple() {
      this.currentRow = this.rowData.find(p => p.jobNo === this.$route.query.key)
      this.againShow('look')
      this.goBack()
    },
    goBack() {
      if (!this.openMultiple) {
        setTimeout(() => {
          this.activeTabName = ''
          this.action = ''
          this.$store.dispatch('app/setCanCloseModule', true)
        }, 500)
      }
      this.$emit('back', this.isRefresh)
    },
    // 查看
    lookHandler() {
      this.againShow('look', this.currentRow)
    },
    // 打印
    onPrint() {
      if (JobUtils.isBlockJob(this.job)) {
        this.$message.info(this.job.jobNo + '已被锁定,不能打印,请联系上级主管解锁!')
        return
      }
      this.$nextTick(async() => {
        // 每个页签的参数
        const params = await this.$refs[this.activeTabName].getPrintData() || null
        if (!params) return
        // 公共参数
        if (!Object.prototype.hasOwnProperty.call(params, 'jobuuid') || !params.jobuuid) {
          params.jobuuid = this.job.uuid
        }
        if (!Object.prototype.hasOwnProperty.call(params, 'JOB_UUID') || !params.JOB_UUID) {
          params.JOB_UUID = this.job.uuid
        }
        console.log('---params--', params)
        this.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
        if (Object.prototype.hasOwnProperty(params, 'ctx')) delete params.ctx
        this.templateSelectorDialog.category = params.category
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        await this.onPrintCallback(params)
        this.templateSelectorDialog.visible = true
      })
    },
    // 组装打印回调函数 优先取 params 里面的回调，再取页签中的回调，这样修改是为了满足国外账单的特殊情况
    onPrintCallback(params) {
      if (Object.prototype.hasOwnProperty.call(params, 'prePrintCallback')) {
        this.prePrintCallback = params.prePrintCallback
        delete params.prePrintCallback
      } else {
        this.prePrintCallback = this.$refs[this.activeTabName].prePrintCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'printedCallback')) {
        this.printedCallback = params.printedCallback
        delete params.printedCallback
      } else {
        this.printedCallback = this.$refs[this.activeTabName].printedCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'v2CheckCallback')) {
        this.v2CheckCallback = params.v2CheckCallback
        delete params.v2CheckCallback
      } else {
        this.v2CheckCallback = this.$refs[this.activeTabName].v2CheckCallback || null
      }
    },
    // 合并当前job【刷新当前job】
    mergeCurrentRow(res) {
      if (res && res.data) {
        Object.assign(this.currentRow, res.data)
        this.currentRow.uuid = res.data.uuid
        this.isGetNewJobInfoFromDb = true
        this.isRefresh = true
      }
    },
    // 根据对象的属性排序[descending 是否降序]
    createComparisonFunction(propertyName, descending = false) {
      return function(object1, object2) {
        const value1 = object1[propertyName]
        const value2 = object2[propertyName]

        if (!descending) {
          return value1 - value2
        } else {
          return value2 - value1
        }
      }
    },
    // 验证规则配置公用
    async checkingManager(checkNode, callBack, callBack2, newJob = null) {
      this.$logger.log('this.job', this.job)
      if (!this.job) return
      let checkType = true
      if (this.job.masterFlag) {
        const lclSlaves = await new SeaExportJob(this.job).getLclSlaves()
        if (lclSlaves && lclSlaves.length > 0) { // 批量验证
          checkType = false
          this.batchCheckingWindow.checkNode = checkNode
          this.batchCheckingWindow.jobs = [this.job, ... lclSlaves]
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.callBack2 = callBack2
          this.batchCheckingWindow.newJob = newJob
          this.batchCheckingWindow.visible = true
        }
      }
      if (checkType) { // 单个验证
        this.checkingWindow.checkNode = checkNode
        this.checkingWindow.callBack = callBack
        this.checkingWindow.callBack2 = callBack2
        this.checkingWindow.newJob = newJob
        this.checkingWindow.visible = true
      }
    },
    addBatchLcl(lclJob) {
      lclJob.path = ''
      console.log('addBatchLcl')
      console.log(lclJob)
      this.onShow('add', this.rowData, lclJob)
    },
    transferTargetRow(action, jobUuid) {
      const selectedRow = this.rowData.find(p => p.uuid === jobUuid)
      if (selectedRow) {
        if (this.viewJobNoSet.has(selectedRow.jobNo)) {
          this.$router.push({ name: 'BookingVerify', query: { openNew: true, key: selectedRow.jobNo }, params: { action }})
        } else {
          this.onShow(action, this.rowData, selectedRow)
        }
      }
    },
    // 加入小票
    addSlavedJob(jobs) {
      for (const job of jobs) {
        job.jobUuid = job.uuid
        job.parentUuid = job.lclMasterUuid
        job.path = job.lclMasterUuid + ',' + job.uuid
        job.dataType = 2 // 小票
        const oldIndex = this.rowData.findIndex(p => p.uuid === job.uuid)
        if (oldIndex >= 0) {
          this.rowData.splice(oldIndex, 1)
        }
      }
      this.rowData = [...this.rowData, ...jobs]
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
    },
    // 移除小票
    removeJobFromMaster(jobKeys) {
      const rows = this.rowData.filter(p => !jobKeys.includes(p.uuid))
      /* for (const row of rows) {
        row.lclMasterUuid = ''
        row.mbl = ''
        row.parentUuid = ''
        row.path = row.uuid
        row.isCompleteRow = false
      }*/
      this.rowData = [...rows]
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
    },
    removeJob(jobUuid) {
      const rows = this.rowData.filter(p => p.uuid !== jobUuid)
      this.rowData = [...rows]
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
      this.currentRow.version = 0
      this.refresh()
    },
    splitHandle(row) {
      this.view = 'detail'
      this.onShow('split', this.rowData, row)
    },
    resetSopTooltip(event) {
      this.sopTooltipOffset = event.offsetX
    },
    resetTab(tabName) {
      this.pendTabSet.delete(tabName)
    },
    syncData(data) {
      Object.assign(this.currentRow, data)
    },
    reload() {
      this.currentRow.version = 0
      this.isRefresh = true
      // 重置子表数据
      for (const key in this.currentRow) {
        if (typeof this.currentRow[key] === 'object') {
          this.currentRow[key] = ''
        }
      }
      this.isGetNewJobInfoFromDb = true
      this.againShow(this.action, this.currentRow)
    },
    globalUploadEnd() {
      if (this.activeTabName !== 'tabFileHistory') {
        this.activeTabName = 'tabFileHistory'
        this.handleTabClick()
      } else {
        this.$refs.tabFileHistory.onShow(this.paramsOfTab, true)
      }
    },
    // 新增
    onAdd() {
      this.$emit('add')
    },
    // 编辑
    toEdit() {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      this.$emit('edit', this.currentRow)
    },
    // 复制
    copyJobHandler() {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.$emit('copy', this.currentRow)
    },
    // 港前、干线、尾程审核
    priceAuditHandle() {
      switch (this.priceAuditCommand) {
        case this.$t('CargoMsg.Cargo_preportAudit'):
          this.toPriceAudit(1)
          break
        case this.$t('CargoMsg.Cargo_TrunkLineAudit'):
          this.toPriceAudit(2)
          break
        case this.$t('CargoMsg.Cargo_TailEndAudit'):
          this.toPriceAudit(3)
          break
      }
    },
    // 港前、干线、尾程审核
    async toPriceAudit(type) {
      const row = this.job
      if (type === 1) {
        await updateInquiryJobState(row.jobUuid, type, 1).then(async res => {
          this.$message.success(this.$t('CargoMsg.Cargo_AuditSuccessfully'))
          await this.mergeCurrentRow(res)
          this.refresh()
        })
      } else if (type === 2) {
        // 港前和尾程 审核 只当作是标记，只有干线审核为真正审核
        this.isTrunkLineApprove = true
        this.inquiryPassAudit(row)
      } else if (type === 3) {
        // 更新尾程审核状态
        await updateInquiryJobState(row.jobUuid, type, 1).then(async res => {
          this.$message.success(this.$t('CargoMsg.Cargo_AuditSuccessfully'))
          await this.mergeCurrentRow(res)
          this.refresh()
        })
      }
    },
    inquiryPassAudit(row) {
      const jobLists = []
      jobLists.push(row)
      this.opVerifyFrameDialog.type = 0
      this.opVerifyFrameDialog.batchPassAudit = false
      this.opVerifyFrameDialog.job = row
      this.opVerifyFrameDialog.jobList = jobLists
      this.opVerifyFrameDialog.submitCallBack = this.acceptSubmitCallBack
      this.opVerifyFrameDialog.visible = true
    },
    // 审核通过
    acceptHandler(type) {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.opVerifyFrameDialog.type = type
      this.opVerifyFrameDialog.batchPassAudit = false
      this.opVerifyFrameDialog.job = this.currentRow
      const jobLists = []
      jobLists.push(this.currentRow)
      this.opVerifyFrameDialog.jobList = jobLists

      this.opVerifyFrameDialog.submitCallBack = this.acceptSubmitCallBack
      this.opVerifyFrameDialog.visible = true
    },
    async acceptSubmitCallBack(result) {
      this.batchJobList = []
      this.opVerifyFrameDialog.result = result
      if (this.opVerifyFrameDialog.jobList.length === 1) {
        // this.copySCNotifyToDoc() 放后端进行同步
        this.batchJobList.push(this.opVerifyFrameDialog.job)
      }
      const jobKeys = Array.from(this.batchJobList, p => p.uuid)
      const callBack = () => { batchCheckJobsCredit(jobKeys).then(res => this.checkCreditResultHandler(res)) }
      // 判断是否开启验证规则
      const checkNode = CheckRuleConstants.NODE_BOOKING_VERIFY.code
      const useCheckRule = Number(this.config.get('useCheckRule')) === 1
      if (useCheckRule) {
        const hasCheckRule = await JobUtils.hasConfigCheckRule(checkNode, this.job.uuid, this.job.lob)
        if (hasCheckRule) {
          this.checkingManager(checkNode, callBack, null, result)
        } else {
          callBack()
        }
      } else {
        callBack()
      }
    },
    // 信控验证返回结果
    checkCreditResultHandler(res) {
      const result = res.data
      if (result && this.creditRestrictionForBooking !== 0) {
        if (this.creditRestrictionForBooking === 2) {
          this.confirmDialogWindow.messageTitle = this.$t('SeaExport.CheckCreditTipOne')
          this.confirmDialogWindow.content = result
          this.confirmDialogWindow.showConfirmBtn = false
          this.confirmDialogWindow.confirmCallBack = null
          this.confirmDialogWindow.visible = true
          return
        }
        if (this.creditRestrictionForBooking === 1) {
          this.confirmDialogWindow.messageTitle = this.$t('SeaExport.CheckCreditTipTwo')
          this.confirmDialogWindow.content = result
          this.confirmDialogWindow.showConfirmBtn = true
          this.confirmDialogWindow.confirmCallBack = this.batchAudit
          this.confirmDialogWindow.visible = true
          return
        }
      }
      this.batchAudit()
    },
    // 审核通过
    async batchAudit() {
      // 订舱预审-审核通过类型1、save2 2、approved2 3、batchUpdateJobs 4、batchApproved
      let verifyType = 0 // 以下接口统一放在后端区分了
      if (this.batchJobList.length === 1) {
        if (this.btn.pretrialReviewConfig && this.btn.pretrialReviewThroughRole) {
          verifyType = 1
          // _job.save2(updateJobSuccessResultHandler, failureHandler)
        } else {
          verifyType = 2
          // _job.approved2(saveJobResultHandler, failureHandler)
        }
      }
      if (verifyType === 0) {
        if (this.btn.pretrialReviewConfig && this.btn.pretrialReviewThroughRole) {
          verifyType = 3
          // Job.batchUpdateJobs(batchJobList, batchUpdateJobSuccessResultHandler, failureHandler)
        } else {
          verifyType = 4
          // Job.batchApproved(batchJobList, batchSaveJobResultHandler, failureHandler)
        }
      }
      const result = this.opVerifyFrameDialog.result
      const jobKeys = Array.from(this.batchJobList, p => p.uuid)
      if (result) {
        result.jobKeys = jobKeys
        result.verifyType = this.opVerifyFrameDialog.verifyType = verifyType
        result.jobState = 0
        result.preverifyState = 2
      }
      this.loading = getLoading()
      if (this.isHc && this.isTrunkLineApprove) {
        await updateInquiryJobState(this.job.jobUuid, 2, 1).then(res => {
          this.job.trunkLineApproveStatus = 1
        })
      }
      approved(result, this.$store.getters.currentOfficeId).then(res => this.approvedResultHandler(res)).finally(() => {
        this.loading.close()
      })
    },
    approvedResultHandler(res) {
      if (res && res.data) Object.assign(this.opVerifyFrameDialog.job, res.data)
      const verifyType = this.opVerifyFrameDialog.verifyType
      switch (verifyType) {
        case 1:
        case 2:
          this.$message.success(this.$t('SeaExport.AuditSuccess'))
          this.refresh()
          break
        case 3:
        case 4:
          this.$message.success(this.$t('SeaExport.BatchAuditSuccess'))
          this.refresh()
          break
        default:
          break
      }
    },
    // 审核拒绝
    rejectHandler(type) {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.rejectWindow.type = type
      this.rejectWindow.jobNo = this.currentRow.jobNo
      this.rejectWindow.rejectCallBack = this.isCooperate ? this.rejectCooperateCallBackHandler : this.rejectCallBackHandler
      this.rejectWindow.visible = true
    },
    rejectCallBackHandler(remark) {
      this.loading = getLoading()
      preVerifyReject(this.currentRow.uuid, remark, 3).then(res => this.preVerifyRejectResultHandler(res)).finally(() => {
        this.loading.close()
      })
    },
    preVerifyRejectResultHandler(res) {
      if (res && res.data) Object.assign(this.currentRow, res.data)
      this.$message.success(this.$t('SeaExport.RefuseSuccess'))
      this.refresh()
    },
    // 复核通过
    btVerifyReviewThroughHandler(type) {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      // 详情单个复核
      const result = {}
      result.jobKeys = [this.currentRow.uuid]
      result.verifyType = 5
      result.jobState = 0
      result.preverifyState = 5
      this.loading = getLoading()
      approved(result, this.$store.getters.currentOfficeId).then(res => {
        Object.assign(this.currentRow, res.data)
        this.$message.success(this.$t('SeaExport.ReviewSuccess'))
        this.refresh()
      }).finally(() => {
        this.loading.close()
      })
      // _job.jobState = 0;
      // _job.preverifyState = 5;
      // _job.approved2(reviewThroughResultHandler, failureHandler);
    },
    // 复核拒绝
    btVerifyReviewRefusalHandler(type) {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      // _job.preverifyState = 6;
      // _job.save2(verifyReviewRefusalResultHandler, failureHandler);
      this.loading = getLoading()
      preVerifyReject(this.currentRow.uuid, '', 6).then(res => {
        if (res && res.data) Object.assign(this.currentRow, res.data)
        this.$message.success(this.$t('SeaExport.ReviewRejectedSuccess'))
        if (type === 1) { // 详情审核通过
          this.$emit('refresh', this.currentRow)
        } else {
          this.toQuery()
          this.currentRow = null
          this.updateControlsState()
          this.gridApi.clearFocusedCell()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 协作状态: 审核通过
    acceptCooperateHandler(type) {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.cooperationVerifyDialog.jobUuid = this.currentRow.uuid
      const cooperate = {}
      Object.assign(cooperate, this.currentRow.cooperate)
      cooperate.businessType = cooperate.businessType ? cooperate.businessType.split(',') : []
      this.cooperationVerifyDialog.cooperate = cooperate
      this.cooperationVerifyDialog.editable = false
      this.cooperationVerifyDialog.config = this.config
      this.cooperationVerifyDialog.job = null
      const seaJob = {
        lob: this.currentRow.lob,
        bookingAgent: this.currentRow.bookingAgent,
        scNo: this.currentRow.scNo,
        carrierAgentId: this.currentRow.carrierAgentId,
        carrierId: this.currentRow.carrierId
      }
      this.cooperationVerifyDialog.job = seaJob
      this.cooperationVerifyDialog.visible = true
    },
    toAcceptCooperationVerifyCallBack(remark) {
      const seaJob = this.cooperationVerifyDialog.job
      this.loading = getLoading()
      updateState({ jobUuid: this.currentRow.uuid, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_APPROVED.code,
        remark: remark, bookingAgent: seaJob.bookingAgent, scNo: seaJob.scNo, carrierAgentId: seaJob.carrierAgentId, carrierId: seaJob.carrierId }).then(res => {
        if (res && res.data) {
          this.currentRow.cooperateStatus = res.data[0].cooperateStatus
          this.$message.success(this.$t('SeaExport.AuditSuccess'))
          this.currentRow.version = 0
          this.isRefresh = true
          this.refresh()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 协作状态: 拒绝
    rejectCooperateCallBackHandler(remark) {
      this.loading = getLoading()
      updateState({ jobUuid: this.currentRow.uuid, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_REFUSED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.currentRow.cooperateStatus = res.data[0].cooperateStatus
          this.$message.success(this.$t('SeaExport.RefuseSuccess'))
          this.refresh()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // im入口值返回
    async getImGroupFunc(paramsOfTab) {
      const result = paramsOfTab.data
      if (!this.imCacheKey || !result || (result && !result.jobNo)) {
        return
      }
      let etdTime = ''
      if (result && result.etd) {
        etdTime = result.etd.slice(0, 10)
      } else {
        etdTime = ''
      }
      const imGroupName = `${result.jobNo}-${etdTime}-${ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', result.dischargingPortCode, 'englishName')}`
      const userInfo = this.$store.getters.userInfo
      // 销售 揽货销售 海外客服 航线负责人 现场操作 单证 自定义岗位1 自定义岗位2
      const personnel = ['sales', 'cargoSalesId', 'overseaOp', 'planner', 'siteOP', 'dc', 'csr', 'userDefinedRoleId1', 'userDefinedRoleId2', 'op']
      const data = {
        tenantId: userInfo.tenantId,
        cargowareCompanyId: result.customerId, // cargoware的合作伙伴，对应b2b的订舱公司
        loginUserId: userInfo.userId,	// 登陆人userId
        customerEmail: result.contactEmail, // 客户邮箱
        otherUserIdList: [userInfo.userId], // 其他内部人userId，userName
        docId: result.jobNo, // 单据Id
        type: '' // 单据type
      }
      if (!data.customerEmail) {
        await this.loadCustomer(data, result)
      }
      for (const item of personnel) {
        if (result[item]) {
          data.otherUserIdList.push(result[item])
        }
      }
      this.$refs.cargoIm.onShow(data, imGroupName)
    },
    async loadCustomer(data, result) {
      console.log('result.customerId======', result)
      let company = { cmpIdx: result.customerId }
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      if (contacts) {
        for (const contact of contacts) {
          if (contact.contactPerson === result.customerContact) {
            data.customerEmail = contact.email
            break
          }
        }
      }
    },
    async getDefaultSeaExportJob() {
      const entityDefValUtil = EntityDefaultValueUtil.getInstance()
      if (!entityDefValUtil.defaultValues) {
        await entityDefValUtil.initEntityDefaultValue()
      }
      this.defaultSeaExportJob = entityDefValUtil.seaExportJob.getData()
    },
    saveDefaultVal() {
      const loading = getLoading()
      EntityDefaultValueUtil.getInstance().saveEntityDefaultValue(['Job', 'SeaExportJob'], this.paramsOfTab).then(() => {
        this.$message.success(this.$t('Message.DefaultValuesAreSavedSuccessfully'))
      }).finally(() => {
        loading.close()
      })
    }
  },
  // 重置行数据
  reset(rows) {
    for (const row of rows) {
      // 标识为脏数据
      row.version = 0
      // 重置子表数据
      for (const key in row) {
        if (typeof row[key] === 'object') {
          row[key] = ''
        }
      }
      row.isCompleteRow = false
    }
  }
}
</script>
